<template>
    <div id="appCapsule">
        <div class="spinner-grow text-primary" style="position: absolute; top: 50%; left: 45%; width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>
<script>
export default {
    name: 'LoadingApp'
}
</script>